import type { ProgressReport } from '@brighterly/lib-core-types/progress-report/interfaces'
import type { ScopeMode } from '@shared/lib/scope'

import { useCsRoutes } from '@shared/api'

import { useProgressReportStore } from '../model/store'

interface ProgressReportApiPayload {
  disciplineId: number
  progressReportId: string | null
  mode: ScopeMode
}

interface ProgressReportApiOptions {
  onStart?: () => void
  onSuccess?: (report: ProgressReport | null) => void
  onError?: (err: any) => void
  onFinish?: () => void
}

export const useProgressReportApi = async (payload: ProgressReportApiPayload, options?: ProgressReportApiOptions): Promise<void> => {
  const { disciplineId, progressReportId, mode } = payload

  if (!progressReportId) {
    options?.onError?.({ message: 'Invalid progress report ID.' })
    return
  }

  const { $axios } = useNuxtApp()

  const progressReportStore = useProgressReportStore()

  const url = useCsRoutes('disciplines.progress-report', {
    '[discipline_id]': disciplineId,
    '[progress_report_id]': progressReportId,
  })

  options?.onStart?.()
  const requestId = progressReportStore.beginReport(disciplineId, mode)

  try {
    const { data } = await $axios.get(url!)
    const report: ProgressReport | null = data.data || null

    progressReportStore.settleReport(disciplineId, requestId, report)
    options?.onSuccess?.(report)
  } catch (err: any) {
    console.error(err)
    progressReportStore.failReport(disciplineId, requestId)
    options?.onError?.(err)
  } finally {
    options?.onFinish?.()
  }
}
